import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import css from './strength-weakness-topic.scss';
import { SCORE_BAND_COLOURS } from '../../containers/activity-mastery/common/strength-and-weaknesses-constants';
import Badge from '../badge/badge';

/**
 * Displays a strength/weakness topic with its result in a coloured badge
 */
class StrengthWeaknessTopic extends Component {
    static propTypes = {
        topicName: PropTypes.string,
        result: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    };

    static defaultProps = {
        topicName: '',
        result: '-'
    };

    getBackgroundColor = (range) => {
        if (range >= 86 && range <= 100) {
            return SCORE_BAND_COLOURS.MASTERED;
        } else if (range >= 66 && range <= 85) {
            return SCORE_BAND_COLOURS.CONSOLIDATING;
        } else if (range >= 50 && range <= 65) {
            return SCORE_BAND_COLOURS.DEVELOPING;
        } else if (range >= 26 && range <= 49) {
            return SCORE_BAND_COLOURS.EMERGING;
        } else if (range >= 0 && range <= 25) {
            return SCORE_BAND_COLOURS.POOR;
        }

        return SCORE_BAND_COLOURS.DEFAULT;
    };

    render() {
        const { topicName, result } = this.props;
        return (
            <div className={css.component}>
                <div className={css.title}>{topicName}</div>
                <Badge
                    content={`${result}%`}
                    background={this.getBackgroundColor(result)}
                />
            </div>
        );
    }
}

export default styleable(css)(StrengthWeaknessTopic);



// WEBPACK FOOTER //
// ./components/strength-weakness-topic/strength-weakness-topic.js